import $ from 'jquery';
import store from "@/store/index";


export function addTabs(path, title) {
  var name = path.replaceAll("/", "");
  store.commit("addKeepAliveCache", path);
  var titleName = ""
  if (store.state.navState == 1) {
    titleName = title.replace(">" + title.split(">")[title.split(">").length - 1], "")
  } else {
    titleName = title
  }
  var submenu = {
    path: path,
    name: name,
    label: titleName,
  };
  store.commit("selectMenu", submenu);
}

// tab删除
export function removeTabs(path) {
  var oldTabList = store.state.tabList || [];
  // 删除tabList中的该对象，从后往前遍历避免索引问题
  for (let i = oldTabList.length - 1; i >= 0; i--) {
    var item = oldTabList[i];
    if (item && item.path === path) {
      oldTabList.splice(i, 1);
    }
  }
  // 删除keepAlive缓存
  store.commit("removeKeepAliveCache", path);
}

// 统计区域高度
export function statisticalSize() {
  setTimeout(() => {
    if ($(".statisticalArea").length != 0) {
      let tabHeight = 0;
      if ($(".el-tabs__header").length != 0) {
        tabHeight = $(".el-tabs__header").outerHeight(true);
      }
      let allHeight = $(".layoutContainer").outerHeight(true);
      let searchHeight = $(".secondFloat").outerHeight(true);
      let val = allHeight - searchHeight - tabHeight - 17;
      $(".statisticalArea").css({ "height": val, "overflow": "auto" });
    }
  }, 50);
}
// 数列表内容高度
export function contentHeight() {
  if ($('.leftData').length !== 0) {
    let leftDataHeight = $('.leftData').outerHeight(true);
    if ($(".scrollClass").length !== 0) {
      let butHeight = $('.topButton').outerHeight(true) == null ? 0 : $('.topButton').outerHeight(true)
      let treeHeader = $(".treeHeader").outerHeight(true) == null ? 0 : $('.treeHeader').outerHeight(true)
      let distance = leftDataHeight - butHeight - treeHeader - 2;
      $(".scrollClass").css('height', distance);
    }
    if ($(".taskCenter").length !== 0) {
      let butHeight = "";
      if ($(".taskCenter").css("display") == "none") {
        butHeight = 0
      } else {
        butHeight = $('.taskCenter').outerHeight(true)
      }
      let taskHeight = leftDataHeight - butHeight;
      $(".taskManualList").css('height', taskHeight)
    }
  }
  if ($(".fromRight").length != 0) {
    let fromRightHeight = $(".fromRight").outerHeight(true);
    if ($(".detailInfo").length != 0) {
      let rightHeight = $(".rightTitle").outerHeight(true) == null ? 0 : $(".rightTitle").outerHeight(true);
      let detailHeight = fromRightHeight - rightHeight;
      $(".detailInfo").css('height', detailHeight);
    }
    if ($(".fromRight .el-form").length != 0) {
      var titleHeight = $(".formTitle").outerHeight(true) == null ? 0 : $(".formTitle").outerHeight(true);
      var fromHeight = fromRightHeight - titleHeight - 5;
      $(".fromRight .el-form").css('height', fromHeight);
    }
  }
}

// 目录展开状态
export let expandData = []
export function stateExpand(data) {
  if (data[0].children.length > 0) {
    for (var i = 0; i < data[0].children.length; i++) {
      if (data[0].children.length > 0) {
        stateExpand(data[0].children)
      }
    }
  } else {
    expandData = data[0]
  }
}
export function expandEvents(data) {
  stateExpand(data)
  return expandData
}
export let treeData = []
export function stateTree(data) {
  if (data[0].children !== null) {
    for (var i = 0; i < data[0].children.length; i++) {
      if (data[0].children !== null) {
        stateTree(data[0].children)
      }
    }
  } else {
    treeData = data[0]
  }
}
export function expandTree(data) {
  stateTree(data)
  return treeData
}
// 展开记录
// 数节点展开
export function nodeExpand(expandList, data) {
  // 保存当前展开的节点
  let flag = false
  expandList.some(item => {
    if (item === data.id) {
      //判断当前节点是否存在，存在不做处理
      flag = true
      return true
    }
  })
  if (!flag) {
    // 不存在则存到数组里
    expandList.push(data.id)
  }
  return expandList
}
export function nodeCollapse(list, data) {
  // 删除当前关闭的节点
  list.some((item, i) => {
    if (item === data.id) {
      list.splice(i, 1)
    }
  })
  removeChildren(list, data)
  return list
}
// 删除树子节点
export function removeChildren(list, data) {
  if (data.children !== null) {
    data.children.forEach(function (item) {
      const index = list.indexOf(item.id)
      if (index !== -1) {
        list.splice(index, 1)
      }
      removeChildren(list, item)
    })
  }
}



// 语种数据
export function languageType() {
  // axios.get(`${sysServerUrl}sys/dict/query?dictType=languageType`).then(res => {
  //   if (res.data.code == 100) {
  //     sessionStorage.setItem('language', JSON.stringify(res.data.data))
  //   }
  // })
}

// 记录访问的菜单
export function accessRecordLog(menu) {
  // axios.get(`${sysServerUrl}sys/access/accessMenu?menu=` + menu).then(res => {

  // })
  // axios.post(`${sysServerUrl}sys/menu/accessMenu`, menu).then(res => {

  // })
}



export function imagePreview(className) {
  setTimeout(() => {
    if ($(className).length > 0) {
      var allWidth = $(className).width();
      var allHeight = $(className).height();
      var imgWidth = $(className + " #img").width();
      var imgHeight = $(className + " #img").height();
      if (imgWidth != 0 && imgHeight != 0) {
        if (allWidth > imgWidth) {
          if (imgHeight > allHeight || imgHeight == allHeight) {
            $(className + " #img").css({ "maxHeight": "100%" });
          } else {
            let topVal = (allHeight - imgHeight) / 2 - 2;
            if (topVal > 0) {
              $(className + " #img").css({ "marginTop": topVal });
            }
          }
        } else {
          if (imgHeight > allHeight || imgHeight == allHeight) {
            $(className + " #img").css({ "maxHeight": "100%" });
          } else {
            let topVal = (allHeight - imgHeight) / 2 - 2;
            if (topVal > 0) {
              $(className + " #img").css({ "marginTop": topVal });
            }
          }
        }
        $(className + " #img").show();
        // 使用全局的loading对象
        window.loading.hide();
      } else {
        imagePreview(className)
        // 使用全局的loading对象
        window.loading.hide();
      }
    }
  }, 120)
}
/**
 * 浏览器初始化
 * @param contentWindow
 * @param manualId
 * @param callback
 */
export function editorInit(contentWindow, manualId, callback) {
  if (contentWindow.hasInit || contentWindow.setContent) {
    contentWindow.hasInit = true;
    contentWindow.paramUrl(cmsServerUrl, manualId);
    contentWindow.setToken(sessionStorage.getItem('token'))
    contentWindow.disabledEditor()
    if (callback) {
      callback()
    }
    return
  }
  contentWindow.onload = function () {
    contentWindow.hasInit = true;
    contentWindow.paramUrl(cmsServerUrl, manualId);
    contentWindow.setToken(sessionStorage.getItem('token'))
    contentWindow.disabledEditor()
    if (callback) {
      callback()
    }
  }
}

// 右键弹框位置
export function contextmenuSeat(event, className) {
  $(className).show()
  var allHeight = $(".el-container").height();
  var allWidth = $(".el-container").width();
  setTimeout(() => {
    var menuHeight = $(className).height();
    var menuWidth = $(className).width();
    if (event.clientY + menuHeight > allHeight) {
      $(className).css('top', event.clientY - menuHeight)
    } else {
      $(className).css('top', event.clientY)
    }
    if (event.clientX + menuWidth > allWidth) {
      $(className).css('left', event.clientX - menuWidth)
    } else {
      $(className).css('left', event.clientX)
    }
  })
}
export function uploadIcon(uploadFilePath) {
  setTimeout(() => {
    var length = $(".el-upload-list.el-upload-list--text").children("li").length;
    for (var i = 0; i < length; i++) {
      var text = $(".el-upload-list.el-upload-list--text").children("li")[i].innerText;
      var type = '';
      if(uploadFilePath != undefined) {
        type = uploadFilePath.substring(uploadFilePath.lastIndexOf(".") + 1).toLowerCase();
      } else{
        type = text.substring(text.lastIndexOf(".") + 1).toLowerCase();
      }
      if ($(".el-upload-list__item.is-ready:nth-child(" + (i + 1) + ")").length != 0) {
        $(".el-upload-list__item.is-ready:nth-child(" + (i + 1) + ")")
          .children("a")
          .children("i")
          .addClass(type);
      }
      if ($(".el-upload-list__item.is-success:nth-child(" + (i + 1) + ")").length != 0) {
        $(".el-upload-list__item.is-success:nth-child(" + (i + 1) + ")")
          .children("a")
          .children("i")
          .addClass(type);
      }
    }
  }, 150);
}
